import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'light-dark',
  standalone: true,
  imports: [
    MatIconModule
  ],
  templateUrl: './light-dark.component.html',
  styleUrl: './light-dark.component.scss'
})
export class LightDarkComponent {
  theme: 'light' | 'dark' = 'light';

  constructor() { 

  }
  toggleTheme(): void {
    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      document.body.classList.toggle('dark');
    }
  }
}
